import { render } from "./PurchaseMenu.vue?vue&type=template&id=04f83518"
import script from "./PurchaseMenu.vue?vue&type=script&lang=js"
export * from "./PurchaseMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__